import useSWR from "swr";

import styles from "./Leaderboard.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import {IView} from "../../../stores/InterfaceStore";
import WatsonApi from "../../../backends/WatsonApi";
import classNames from 'classnames';
import {isSchoolFeedStandalone} from "../../../utils/SchoolBlocksUtilities";
import {useSchoolFeedUrlQuery} from "../../../hooks/useSchoolFeedData";
import ClickableLink from "../../utilities/ClickableLink";
import {usePathname} from "next/navigation";
import {useStores} from "../../../stores/useStores";

export default function Leaderboard(props) {
    const {interfaceStore, organizationStore} = useStores();
    const urlQuery = useSchoolFeedUrlQuery();
    const pathname = usePathname();

    const {data} = useSWR(`leaderboard/${organizationStore.currentOrganization.id}`, async () => {
        const client = await WatsonApi();
        const response = await client.apis.organizations.organizations_leaderboard({
            id: organizationStore.currentOrganization.id,
        })
        return JSON.parse(response.data);
    }, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
    })

    let href;
    if (interfaceStore.view === IView.SCHOOLFEED_PAGE || (interfaceStore.view === IView.DEFAULT && isSchoolFeedStandalone())) {
        href = {
            pathname,
            query: {...urlQuery, currentView: "leaderboard"}
        }
    } else if (interfaceStore.view !== IView.LEADERBOARD) {
        href = "/leaderboard";
    }

    return <div className={classNames(styles.container, styles.widget)}>
        <div>
            <h3>DISCUSSION LEADERBOARD</h3>
            {href && <ClickableLink href={href}
            >Learn More <FontAwesome prefix={'far'} name={'fa-question-circle'} /></ClickableLink>}
        </div>
        <ol>
            {data && data.map(d => {
                const itemClassName = classNames({
                    [styles.item]: true,
                    [styles.itemIsMe]: d["me"],
                })
                return <li className={itemClassName}>
                    {d.rank} - {d.name}
                </li>
            })}
        </ol>
    </div>
}
